import React, { useEffect, useState, type FC } from 'react';

import { useUnreadInlineComments } from '@confluence/unread-comments';

import { CommentsPanel } from './CommentsPanel';
import { Loading } from './components/Loading';
import { CurrentView } from './hooks/useCommentsPanel';

type CommentsPanelWrapperProps = {
	openWithView?: CurrentView;
};

export const CommentsPanelWrapper: FC<CommentsPanelWrapperProps> = ({ openWithView }) => {
	const [showLoader, setShowLoader] = useState(!openWithView);
	const [{ unreadCommentsListState: unreadCommentList, isUnreadQueryLoading }] =
		useUnreadInlineComments();

	// As long as we don't have a "default" view to open the panel to show then we should check
	// if the unread call is still in flight to figure out which view to show if there are unread
	useEffect(() => {
		if (!openWithView) {
			setShowLoader(isUnreadQueryLoading);
		}
	}, [isUnreadQueryLoading, openWithView]);

	let viewToShow = CurrentView.OPEN;

	if (openWithView) {
		viewToShow = openWithView;
	} else {
		viewToShow = unreadCommentList.length === 0 ? CurrentView.OPEN : CurrentView.UNREAD;
	}

	return showLoader ? <Loading /> : <CommentsPanel currentView={viewToShow} />;
};
